import { useMutation } from 'react-query';
import { httpService } from '../../../services/http.service';
import { BASE_URL } from '../../../constants/endpoints';
import { IServerErrorResponse } from '../../../types';
import { flattenServerErrorResponse } from '../../../helpers/errors.helper';

interface IProps {
  customerId: string;
}

interface ChangeNaicsBody {
  segment: string;
  naicsIndustry: string;
}

export const useChangeNaicsMutation = (
  { customerId }: IProps,
  onSuccess: (response: any) => void,
  onError: (error: any) => void,
) => useMutation(
  'changeNaics',
  async ({ segment, naicsIndustry }: ChangeNaicsBody) => {
    const { data } = await httpService.put(
      `${BASE_URL}/api/v1/user/${customerId}/industry`,
      { segment, naicsIndustry },
    );
    return data;
  },
  {
    onSuccess: () => onSuccess(true),
    onError: (error: IServerErrorResponse) => {
      onError(flattenServerErrorResponse(error));
    },
  },
);
